import { render } from "./AdvertiserReportingOverviewMonitor.vue?vue&type=template&id=4c476b7c"
import script from "./AdvertiserReportingOverviewMonitor.vue?vue&type=script&lang=js"
export * from "./AdvertiserReportingOverviewMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/53/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QTooltip,QTabs,QTab,QSkeleton,QIcon});
